import { render, staticRenderFns } from "./OnboardingVerificationRecord.vue?vue&type=template&id=ccb095a0&scoped=true&"
import script from "./OnboardingVerificationRecord.vue?vue&type=script&lang=js&"
export * from "./OnboardingVerificationRecord.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingVerificationRecord.vue?vue&type=style&index=0&id=ccb095a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb095a0",
  null
  
)

export default component.exports